import { createAppConstants } from '@hwm/ui-lib';

export const styleConstants = createAppConstants({}, {
  colors: {
    primaryColor: '#00A9E0',
    primaryDark: '#002F6C',
    warningColor: '#DF7C1F',
    secondaryColor: '#596794',
    black: '#000000',
    darkBlue: '#243259',
    green: '#18c474',
    grey: '#6a7082',
    grey2: '#E6E8F2',
    inputBorder: '#CDC9C9',
    lightGrey: '#F2F2F2',
    orange: '#dc8f15',
    red: '#c2224f',
    redSecondary: '#D1234D',
    yellow: '#e5de00',
    disabledBackground: '#F0F1F5',
    violet: '#6574a0',
    purple: '#541675',
    white: '#FFF',
    fontDefaultColor: 'rgba(255, 0, 0, 0.7)',
    fontDarkBlue: '#353E53',
    charts: {
      background: '#F4F4F4',
      devices: {
        active: '#2D48D9',
        leak: '#F60000',
        leak24h: '#FF4956',
      },
      breakdown: {
        investigationCleared: '#B610B1',
        leakNotCategorised: '#F60000',
        investigationOngoing: '#FFFF00',
        awaitingRepair: '#01FB13',
        customerSideLeak: '#FF6A00',
        confirmedNoiseSource: '#CA5400',
        prvMode: '#00FFFF',
        maintenance: {
          quiet: '#EEC100',
          sensorCheck: '#3392FF',
          orientationAlarm: '#17E255',
          constantLevel: '#D033FF',
        },
        customCategory1: '#00ffaf',
        customCategory2: '#800000',
        customCategory3: '#c8a2c8',
      },
      averageRuntime: {
        investigationOngoing: '#228EC2',
        investigationOngoingAwaitingRepair: '#228EC2',
        awaitingRepair: '#228EC2',
      },
    },
  },
  siteMapColors: {
    noLeak: '#2D48D9',
    quiet: '#EEC100',
    investigationOngoing: '#FFFF00',
    awaitingRepair: '#01FB13',
    investigationCleared: '#B610B1',
    customerSideLeak: '#FF6A00',
    cns: '#ED7D31',
    prvMode: '#00FFFF',
    surveyMeasurement: '#32557D',
    prvLogger: '#9932CC',
    flowLogger: '#BA7A57',
    pressureLogger: '#810041',
    flowPressureLogger: '#FFC0CB',
    leak: '#F60000',
    leakInside: '#F60000',
    quietInLeakBackground: '#FF0000',
    quietInLeakForeground: '#EEC100',
    customCategories: ['#00ffaf', '#800000', '#c8a2c8'],
  },
  chartTooltip: {
    fontFamily: 'Ubuntu Sans, Helvetica, Arial, sans-serif',
    fontSize: '12px',
    padding: '4px 10px 4px 10px',
    color: '#008ffb',
  },
  leakCategorisation: {
    low: '#ffff66',
    mid: '#ffb07b',
    high: '#ff7979',
  },
  quietStatusColor: '#ffb6c1',
  formField: {
    fontSize: '16px',
    backgroundColor: '#f0f1f5',
    fontWeight: 700,
    fontStyle: 'inherit',
    padding: '4px 10px 4px 10px',
  },
  orientationOK: {
    background: '#008000',
    borderColor: '#008000',
    fontSize: '16px',
    fontWeight: 700,
    fontStyle: 'inherit',
    padding: '4px 10px 4px 10px',
    color: '#FFFFFF',
    '& input': {
      backgroundColor: '#008000',
      color: '#FFF !important',
    },
  },
  orientationWarning: {
    background: '#8b0000',
    borderColor: '#8b0000',
    fontSize: '16px',
    fontWeight: 700,
    fontStyle: 'inherit',
    padding: '4px 10px 4px 10px',
    color: '#FFFFFF',
    '& input': {
      backgroundColor: '#8b0000',
      color: 'white !important',
    },
  },
} as const);
